function initCarousel() {
    let $featuredCarouselScroll = $('.featured-category-carousel__product-tiles-container');
    $featuredCarouselScroll.each(function (key, item) {
        if(this.id === '' || this.id === undefined) {
            var sliderIdName = 'featured-category-carousel' + key;
            this.id = sliderIdName;
            var sliderId = '#' + sliderIdName;

            $(sliderId).slick({
                dots: false,
                infinite: false,
                speed: 1000,
                slidesToShow: 4,
                slidesToScroll: 1,
                autoplay: false,
                autoplaySpeed: 5000,
                arrows: true,
                mobileFirst: false,
                responsive: [
                    {
                        breakpoint: 1161,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 481,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
        }
    });
}
function setCarouselContentHeight() {
    let featuredCategoryCarousels = $('.featured-category-carousel');
    featuredCategoryCarousels.each(function() {
        const innerElements = $(this).find('.featured-category-carousel__product-description');
        let maxHeight = 0;
        innerElements.each(function() {
            const height = $(this).height();
            if(height > maxHeight) {
                maxHeight = height;
            }
        });

        innerElements.each(function() {
            $(this).outerHeight(maxHeight);
        });
    });
}

$(function () {
    initCarousel();

    setTimeout(function () {
        setCarouselContentHeight();
    }, 300);

    $(window).resize(function () {
        setTimeout(function () {
            setCarouselContentHeight();
        }, 300);
    });
});
